import React, { useEffect, useState } from "react"
import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import List from "../../../components/List/List"
import { selectionMemory } from "../../../Objects/Memory/Memory"
import { EEnableStatusType } from "../../../Enum/EEnableStatusType"
import { useGetSelection } from "../../../hooks/Selection/useGetSelection"
import { SelectionEntity } from "../../../Objects/Selection/SelectionEntity"
import { SelectionPupop } from "./SelectionPupop"
import { SelectionOptionEntity } from "../../../Objects/Selection/SelectionOptionEntity"
import { useTranslation } from "react-i18next"
import { useOnboardingCreatePopup } from "../../../hooks/useOnboardingCreatePopup"
import { ImportDataPopup } from "../../../components/DataImport/ImportDataPopup"

export const SelectionPage: React.FC = () => {
  const [enable, setEnable] = useState(false)

  const [enableImport, setEnableImport] = useState(false)

  const { t } = useTranslation()

  const { handleGetSelection } = useGetSelection()

  const [selection, setSelection] = useState<SelectionEntity | undefined>(undefined)

  useEffect(() => {
    handleGetSelection(() => {})
  }, [])

  useOnboardingCreatePopup(() => {
    setSelection(undefined)

    setEnable(true)
  })

  const handleCopySelection = () => {
    if (!selection) {
      return
    }

    setSelection(
      new SelectionEntity({
        ...selection,
        id: -1,
        options: selection.options.map((option) =>
          new SelectionOptionEntity({ ...option, id: -1, iconUrl: "", icon: null }),
        ),
      }),
    )
  }

  return (
    <>
      <div className={defaultStyle.containerList}>
        <List
          enableLocalPagination
          messageCount={t("list:label_selection_page_message_count")}
          messageEmpty={t("list:label_selection_page_message_empty")}
          nameFindSearch={t("list:label_selection_page_place_holder")}
          data={selectionMemory.getListCards(true)}
          nameDropdown={Object.mapEnumToStrings(EEnableStatusType)}
          handleAddButton={() => {
            setSelection(undefined)
            setEnable(true)
          }}
          handleImportFloatButton={() => setEnableImport(true)}
          handleRefreshButton={() => handleGetSelection(() => {})}
          handleOnClick={(id) => {
            setSelection(selectionMemory.findById(id))
            setEnable(true)
          }}
        />
      </div>

      {enable && (
        <SelectionPupop
          selection={selection}
          title={
            selection && selection.id !== -1 ? t("selection:title_popup_edite") : t("selection:title_popup_create")
          }
          onClose={() => setEnable(false)}
          onCopy={handleCopySelection}
        />
      )}

      {enableImport && (
        <ImportDataPopup
          target="opcoes"
          title={t("dataImport:title", { target: t("dataImport:target_options") })}
          onClose={() => setEnableImport(false)}
          onImported={() => handleGetSelection(() => {})}
        />
      )}
    </>
  )
}
